import { create } from 'zustand';
import { persist } from 'zustand/middleware';
export const usePreferences = create()(persist((set) => ({
    theme: 'system',
    language: null,
    telemetry: false,
    acceptedLegal: false,
    setTheme: (theme) => set({ theme }),
    setLanguage: (language) => set({ language }),
    setTelemetry: (telemetry) => set({ telemetry }),
    acceptLegal: () => set({ acceptedLegal: true }),
}), { name: 'supadown:prefs' }));
